<template>
<div class="imcLogin">
    <div class="main-login">
      <p><img src="../../assets/login/loding.gif" alt=""></p>
     <p class="big-font">身份认证中</p>
     <p class="">请勿关闭此页面，稍后进行跳转</p>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "orgpage",
  data() {
    return {
      appId:"",
      code:"",
      tenant:"",
    };
  },
  methods: {
    login(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/login/imc";
      param.data={
        "appId":this.appId,
        "code":this.code,
        "tenant":this.tenant,
      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          localStorage.setItem('userName',res.data.userName);
          localStorage.setItem('userId',res.data.userId);
          sessionStorage.setItem('token',res.data.token);
          this.$router.push("/areaUer");
        }else{
          this.$message.error('账号密码错误!');
        }
      })
    }
  },
  mounted() {
    this.appId=this.$route.query.appId
    this.code=this.$route.query.code
    this.tenant=this.$route.query.tenant
    this.login()
  },
  watch:{

  },
  components: {

  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.imcLogin {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-login{
  width: 200px;
  height: 200px;
  text-align: center;
  font-size: 14px;
  position: absolute;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  color: #000;
  p{
    width: 100%;
  }
  .big-font{
    font-size: 20px;
    margin: 10px 0;
  }
}
</style>

